import Papa from 'papaparse'

import raw from '../assets/weather.csv'
import { WeatherInfo } from './EpwMap.types'

const pre_link = {
  'DOE': 'https://energyplus-weather.s3.amazonaws.com', 
  'ONEBUILDING': 'https://climate.onebuilding.org'
}

export const sources = [
  ["CSWD", '#a6cee3'], 
  ["CWEC", '#1f78b4'], 
  ["ETMY", '#b2df8a'], 
  ["IGDG", '#33a02c'],
  ["IMGW", '#fb9a99'], 
  ["INETI", '#e31a1c'], 
  ["ISHRAE", '#fdbf6f'], 
  ["ITMY", '#ff7f00'],
  ["IWEC", '#0000ff'], 
  ["KISR", '#6a3d9a'], 
  ["MSI", '#ffff99'], 
  ["NIWA", '#b15928'],
  ["RMY", '#8dd3c7'], 
  ["SWEC", '#ffffb3'], 
  ["SWERA", '#008000'], 
  ["TMY3", '#fb8072'],
  ["TMY2", '#80b1d3'], 
  ["TMY", '#fdb462'], 
  ["CTZ2010", '#b3de69'], 
  ["WYEC2", '#fccde5'],
  ["INMET", '#964B00'], 
  ["BBSR", '#bc80bd'], 
  ["TRY", 'red'], 
  ["ISHRAE2014", '#ffed6f'],
  ["UHK", '#a6cee3'], 
  ["CTZRV2",'#1f78b4'],
  ["_", '#80b1d3']
]

//console.log(process.env.NODE_ENV)

export const parseCSV = (fnc: any) => {

  if (process.env.NODE_ENV === 'development') {
    Papa.parse(raw, {
      download: true,
      error: (err) => console.log(err),
      complete: (input) => {
        const records = input.data
        const output = records.map(([
          id,
          station_name,
          data_source,
          lat,
          lon,
          http_link,
          host]) => {
            // Avoid dataset errors
            if (!station_name) return {}
            return <WeatherInfo> {
              id: id,
              station: station_name,
              source: data_source,
              lat: Number(lat),
              lon: Number(lon),
              link: pre_link[host.toUpperCase()] + http_link,
              host: host,
              color: sources?.find(elm => data_source.includes(elm[0]))?.at(1) ?? '#80b1d3'
          }
        })
        // Remove empty objects
        const arr = output.filter(element => {
          if (
            typeof element === 'object' &&
            Object.keys(element).length === 0
          ) {
            return false
          } else {
            return true
          }
        })
        fnc(arr)
      }
    })
  } else {
    const output = raw.map(([
      id,
      station_name,
      data_source,
      lat,
      lon,
      http_link,
      host]) => {
        // Avoid dataset errors
        if (!station_name) return {}
        return <WeatherInfo> {
          id: id,
          station: station_name,
          source: data_source,
          lat: Number(lat),
          lon: Number(lon),
          link: pre_link[host.toUpperCase()] + http_link,
          host: host,
          color: sources?.find(elm => data_source.includes(elm[0]))?.at(1) ?? '#80b1d3'
        }
    })
    // const arr = output.map(el => el.source)
    // .filter((value, index, array) => array.indexOf(value) === index)
    // console.log(arr)

    // Remove empty objects
    const arr = output.filter(element => {
      if (
        typeof element === 'object' &&
        Object.keys(element).length === 0
      ) {
        return false
      } else {
        return true
      }
    })
    fnc(arr)
  }
}
